<template>
  <div class="layout-card is-shadow-box is-shadow-box--hover">
    <div class="layout-name-container">
      <span class="layout-name">
        {{ layout.name }}
      </span>
    </div>
    <div class="layout-data">
      <div class="layout-data__details">
        <ul class="">
          <li class=""><span class="">Some details 1</span></li>
          <li class=""><span class="">Some details 2</span></li>
          <li class=""><span class="">Some details 3</span></li>
          <li class=""><span class="">Some details 4</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutCard',
  components: {
  },
  props: {
    layout: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .layout-card {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    position: relative;
    align-items: center;
    overflow: hidden;
    background: white;
    padding: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    .layout-name-container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
    }
    .layout-name {
      font-size: 20px;
      font-family: 'DINNextLTPro-Medium';
      width: 100%;
      line-height: 1.3;
    }
    .layout-data {
      display: flex;
      gap: 1rem;
      width: 100%;
      transition: all 0.3s ease;
      &__logo {
        width: 150px;
        height: 150px;
        position: relative;
        // border-radius: $radiusMd;
        // overflow: hidden;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: top;
        }
        .no-logo {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: $inputBackgroundColor;
          text-align: center;
          font-size: 14px;
          .svg-inline--fa {
            color: $colorTextSemi;
            opacity: 0.3;
            font-size: 22px;
          }
          .click-to-add {
            color: $colorTextSemi;
          }
        }
      }
      
      &__details {
        height: 100%;
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
          font-size: 1rem;
          height: 100%;
          overflow-y: auto;
        }
      }
    }

    
  }
</style>